import { DateTime } from "luxon";
import Markdown from "markdown-to-jsx";
import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import SpeakerElement from "../speaker/Speaker";

interface EventAgendaDetailModalProps {
    show: boolean;
    session: any;
    setShowDetail: Dispatch<SetStateAction<boolean>>;
}

const EventAgendaDetailModal: FunctionComponent<EventAgendaDetailModalProps> = (props) => {
    const { show, session, setShowDetail } = props;

    return (
        <Modal className="event__session_modal" size="xl" backdrop={true} centered show={show} scrollable onHide={() => setShowDetail(false)}>
            <Modal.Header className="pb-1 pt-4 px-4" closeButton onHide={() => setShowDetail(false)}>
                <Modal.Title>
                    <Row>
                        <Col>
                            <small className="event__agenda-item-meta">
                                <strong>{DateTime.fromISO(session.start).toFormat('HH:mm')} - {DateTime.fromISO(session.end).toFormat('HH:mm')}</strong>
                                {session.location && session.location !== '' && ` | ${session.location}`}
                                {session.session_type.title && session.session_type.title !== '' && ` | ${session.session_type.title}`}
                            </small>
                        </Col>
                    </Row>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-2 px-4 pb-4">
                <Row>
                    <Col>
                        <h3 className="event__agenda-item-title">{session.title}</h3>
                    </Col>
                </Row>
                {session.speaker && session.speaker.length > 0 &&
                    <Row className="align-items-start mb-4 event__agenda-item-speaker">
                        {session.speaker.map((speaker: any, index: number) =>
                            <SpeakerElement key={index} speaker={speaker} agendaModalVisible={show} />
                        )}
                    </Row>

                }
                {session.description &&
                    <Markdown className="event__agenda-item-description">{session.description}</Markdown>
                }
            </Modal.Body>
        </Modal>
    );
}

export default EventAgendaDetailModal;